import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { devConfig } from '../../../config/config'; // Importing development configuration

/**
 * Class representing the PagoPremioView.
 * @extends JetView
 */
export default class PagoPremioView extends JetView {
    /**
     * Configures the view layout.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration
        const theme = this.app.config.theme; // Theme configuration

        // Left section of the form with input fields
        const left = {
            margin: 5,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text', // Text input for Id
                            name: 'Id',
                            label: "<span class='icon-drivers-license-o'></span>" + _('Id'), // Localized label
                            labelPosition: 'top',
                            disabled: true, // Input is disabled
                        },
                        {
                            view: 'text', // Text input for Name
                            name: 'Name',
                            label: "<span class='icon-user'></span>" + _('Nombre'), // Localized label
                            labelPosition: 'top',
                            disabled: true, // Input is disabled
                        },
                        {
                            view: 'combo', // Combo box for State selection
                            name: 'State',
                            label: "<span class='icon-state'></span>" + _('Estado'), // Localized label
                            options: [
                                // Options for the combo box
                                { id: '', value: _('None') },
                                { id: 'A', value: _('Activado') },
                                { id: 'C', value: _('Cancelado') },
                                { id: 'I', value: _('Inactivado') },
                            ],
                            labelPosition: 'top',
                            disabled: true, // Input is disabled
                        },
                    ],
                },
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'text', // Text input for Currency
                            name: 'Currency',
                            label: "<span class='webix_icon mdi mdi-coin'></span>" + _('Moneda'), // Localized label
                            labelPosition: 'top',
                            disabled: true, // Input is disabled
                        },
                        { id: 'grav', gravity: 2 }, // Gravity for layout management
                    ],
                },
            ],
        };

        // Upper section of the form
        const upper_section = {
            css: 'father-container',
            height: screen == 'small' ? 250 : 0, // Conditional height based on screen size
            cols: [left],
        };

        // Main form configuration
        return {
            view: 'form',
            id: 'formPago', // Unique identifier for the form
            rows: [upper_section],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} form - The form instance.
     */
    init(form) {
        $$('formPago').hide(); // Hides the form initially
        this.on(this.app, 'agentForm:data', (premio) => {
            // Event listener for data updates
            form.setValues(premio); // Sets form values with received data
            console.log('premio', premio); // Logs the received data
        });
        webix.ready(function () {
            // Executes when Webix is ready
            if (screen.width < 500) {
                // Conditional check for screen width
                $$('grav').hide(); // Hides the gravity element on small screens
            }
        });
    }
}

// FILE DOCUMENTED
